import React from 'react';

/** Underline tab bar. Controlled via value/onChange or uncontrolled by defaultValue. */
export default function Tabs({ tabs = [], value, defaultValue, onChange, style, ...rest }) {
  const [internal, setInternal] = React.useState(defaultValue ?? (tabs[0] && tabs[0].id));
  const active = value !== undefined ? value : internal;
  const select = (id) => {
    if (value === undefined) setInternal(id);
    onChange && onChange(id);
  };
  return (
    <div role="tablist" style={{ display: 'flex', gap: 'var(--space-5)', borderBottom: '1px solid var(--line)', ...style }} {...rest}>
      {tabs.map((t) => {
        const on = t.id === active;
        return (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={on}
            onClick={() => select(t.id)}
            style={{
              appearance: 'none', background: 'none', border: 'none', cursor: 'pointer',
              padding: '0 0 12px', marginBottom: -1,
              fontFamily: 'var(--font-sans)', fontWeight: on ? 'var(--w-bold)' : 'var(--w-medium)',
              fontSize: 'var(--text-base)', letterSpacing: 'var(--track-tight)',
              color: on ? 'var(--ink)' : 'var(--ink-muted)',
              borderBottom: on ? '2px solid var(--ink)' : '2px solid transparent',
              transition: 'color var(--dur-fast) var(--ease-out)',
              display: 'inline-flex', alignItems: 'center', gap: 8,
            }}
          >
            {t.label}
            {t.count != null && (
              <span style={{
                fontSize: 'var(--text-xs)', fontWeight: 'var(--w-medium)',
                color: on ? 'var(--science-600)' : 'var(--ink-faint)',
              }}>{t.count}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
